export default __webpack_public_path__ + "static/media/28t.9e567d08.jpg";